import React, { Component } from 'react'
import { Switch, Route } from 'react-router-dom'

import Template from './Template'
import T from '../SPRINTA/translate/T'

import Home from './pages/Home'
import Profile from './pages/Profile'

class App extends Component {
  componentWillMount() {
    T.handleUpdate( () => this.forceUpdate() )
  }

  render() {
    return (
      <Template>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/user/:username" component={Profile} />
          <Route exact path="/user/:username/:page" component={Profile} />
          <Route exact path="/user/:username/:page/:subpage" component={Profile} />
          <Route render={() => {
            window.location.href = 'https://app.sprinta.com.br/404'
          }}/>
        </Switch>
      </Template>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./src/App/index.js